import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getLocationTypesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOCATION_TYPE_LIST.METHOD](APIConfig.LOCATION_TYPE_LIST.URL, payload);
}
const verifyLocation = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_LOCATION.METHOD](APIConfig.VERIFY_LOCATION.URL, payload);

}
const addLocation = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CREATE_LOCATION.METHOD](APIConfig.CREATE_LOCATION.URL, payload);
}

const addLocationInformation = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_INFORMATION.METHOD](APIConfig.ADD_LOCATION_INFORMATION.URL(locationId), payload);
}

const addPrimaryContactDetails = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_PRIMARY_CONTACT_DETAILS.METHOD](APIConfig.ADD_LOCATION_PRIMARY_CONTACT_DETAILS.URL(locationId), payload);
}

const addAdminDetails = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_ADMIN_DETAILS.METHOD](APIConfig.ADD_LOCATION_ADMIN_DETAILS.URL(locationId), payload);
}


const sendAdminVerificationEmail = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_LOCATION_ADMIN_VERIFICATION_EMAIL.METHOD](APIConfig.SEND_LOCATION_ADMIN_VERIFICATION_EMAIL.URL, payload);
}

const addLocationAdmin = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_ADMIN.METHOD](APIConfig.ADD_LOCATION_ADMIN.URL(locationId), payload);
}
const editAdminDetails = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_LOCATION_ADMIN_DETAILS.METHOD](APIConfig.EDIT_LOCATION_ADMIN_DETAILS.URL(facilityId), payload);
}
const getLocationDetails = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VIEW_LOCATION.METHOD](APIConfig.VIEW_LOCATION.URL(locationId), payload);
}

const getPhysicianList = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_PHYSICIAN_LIST.METHOD](APIConfig.GET_LOCATION_PHYSICIAN_LIST.URL(locationId), payload);
}

const linkPhysicianToLocation = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LINK_PHYSICIAN_TO_LOCATION.METHOD](APIConfig.LINK_PHYSICIAN_TO_LOCATION.URL(locationId), payload);
}

const addCriticalDetails = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_CRITICAL_DETAILS.METHOD](APIConfig.ADD_LOCATION_CRITICAL_DETAILS.URL(locationId), payload);
}

const linkPanelsToLocation = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LINK_LOCATION_PANELS.METHOD](APIConfig.LINK_LOCATION_PANELS.URL(locationId), payload);
}

const addBillingDetails = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_BILLING_DETAILS.METHOD](APIConfig.ADD_LOCATION_BILLING_DETAILS.URL(locationId), payload);
}

const addBloodFlowInformation = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_BLOOD_DRAW_DETAILS.METHOD](APIConfig.ADD_LOCATION_BLOOD_DRAW_DETAILS.URL(locationId), payload);
}


const addLocationAccountPreferences = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_ACCOUNT_PREFERENCE.METHOD](APIConfig.ADD_LOCATION_ACCOUNT_PREFERENCE.URL(locationId), payload);
}

const getLocationListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOCATION_LIST_LITE.METHOD](APIConfig.LOCATION_LIST_LITE.URL, payload);
}

const getFacilityLocation=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_LOCATION.METHOD](APIConfig.FACILITY_LOCATION.URL,payload);
}

const getICD10CodesList = (panelCode: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ICD_CODES.METHOD](APIConfig.GET_ICD_CODES.URL(panelCode), payload);
}

const getICD10CodesFavouriteList = (LocationId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ICD_CODES_FAVOURITE_LIST.METHOD](APIConfig.GET_ICD_CODES_FAVOURITE_LIST.URL(LocationId), payload);
}

const deleteLocation = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_LOCATION.METHOD](APIConfig.DELETE_LOCATION.URL(locationId), payload);
}

const recoverLocation = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.RECOVER_LOCATION.METHOD](APIConfig.RECOVER_LOCATION.URL(locationId), payload);
}
const getLocationPhysicianDetails = (physicianID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_PHYSICIAN_DETAILS.METHOD](APIConfig.GET_FACILITY_PHYSICIAN_DETAILS.URL(physicianID), payload);
}

const editLocationDetails = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_LOCATION_INFORMATION_DETAILS.METHOD](APIConfig.EDIT_LOCATION_INFORMATION_DETAILS.URL(locationId), payload);
}
const downloadLocationCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOCATION_CSV_DOWNLOAD.METHOD](APIConfig.LOCATION_CSV_DOWNLOAD.URL, payload);
}
const toggleActiveStatus = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_LOCATION_ACTIVE_STATUS.METHOD](APIConfig.TOGGLE_LOCATION_ACTIVE_STATUS.URL(locationId), payload);
}
const unLinkPhysicianToLocation = (locationId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UNLINK_PHYSICIAN_TO_LOCATION.METHOD](APIConfig.UNLINK_PHYSICIAN_TO_LOCATION.URL(locationId), payload);
}

const addLocationTestAndPanels = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_TEST_AND_PANELS.METHOD](APIConfig.ADD_LOCATION_TEST_AND_PANELS.URL(locationId), payload);
}

const getLocationTestAndPanels = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_TEST_AND_PANELS.METHOD](APIConfig.GET_LOCATION_TEST_AND_PANELS.URL(locationId), payload);
}

const getLocationPanels = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_PANELS.METHOD](APIConfig.GET_LOCATION_PANELS.URL(locationId), payload);
}

const getLocationTests = (locationId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_TESTS.METHOD](APIConfig.GET_LOCATION_TESTS.URL(locationId), payload);
}

const getLocationAdminsList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_ADMINS_LIST.METHOD](APIConfig.GET_LOCATION_ADMINS_LIST.URL, payload);
}
const getLocationUserDetails = () => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LOCATION_USER_DETAILS.METHOD](APIConfig.GET_LOCATION_USER_DETAILS.URL);
}
const addLocationUserDetails = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LOCATION_USER_DETAILS.METHOD](APIConfig.ADD_LOCATION_USER_DETAILS.URL, payload);

}
const removeLocationAssignedUser = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_LOCATION_ASSIGNED_USER.METHOD](APIConfig.REMOVE_LOCATION_ASSIGNED_USER.URL, payload);

}
const LocationService = {
    getLocationTypesList,
    addLocation,
    addLocationInformation,
    addPrimaryContactDetails,
    addLocationAdmin,
    sendAdminVerificationEmail,
    addAdminDetails,
    getLocationDetails,
    getICD10CodesList,
    verifyLocation,
    linkPhysicianToLocation,
    unLinkPhysicianToLocation,
    addCriticalDetails,
    linkPanelsToLocation,
    addBillingDetails,
    addLocationAccountPreferences,
    addBloodFlowInformation,
    getPhysicianList,
    getLocationListLite,
    getFacilityLocation,
    deleteLocation,
    recoverLocation,
    getLocationPhysicianDetails,
    editLocationDetails,
    downloadLocationCSV,
    toggleActiveStatus,
    getICD10CodesFavouriteList,
    editAdminDetails,
    addLocationTestAndPanels,
    getLocationTestAndPanels,
    getLocationPanels,
    getLocationTests,
    getLocationAdminsList,
    getLocationUserDetails,
    addLocationUserDetails,
    removeLocationAssignedUser,
}

export default LocationService;
